"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApprovalSheetCollisionPopover = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var react_intl_1 = require("react-intl");
var Warning_1 = __importDefault(require("@material-ui/icons/Warning"));
var utils_1 = require("../../../utils");
var useBadgeStyles = styles_1.makeStyles(function (theme) {
    var _a = theme.variables.palette.approval, borderRadiusBase = _a.borderRadiusBase, backgroundColorWarning = _a.backgroundColorWarning, colorWarning = _a.colorWarning, colorBlackLight = _a.colorBlackLight;
    var badgeBorderWidth = 0;
    var badgePadding = theme.spacing(1) + "px " + theme.spacing(2) + "px";
    return {
        badge: {
            cursor: 'pointer',
            borderRadius: borderRadiusBase,
            backgroundColor: backgroundColorWarning,
            color: colorWarning,
            borderWidth: badgeBorderWidth,
            padding: badgePadding,
            '&::-moz-focus-inner': {
                borderWidth: badgeBorderWidth,
                padding: badgePadding,
            },
        },
        badgeText: {
            color: colorBlackLight,
        },
        gridContainer: {
            margin: 0,
        },
    };
});
var usePopoverStyles = styles_1.makeStyles(function (theme) {
    var _a = theme.variables.palette.approval, collisionPopoverWidth = _a.collisionPopoverWidth, fontSizeSmaller = _a.fontSizeSmaller;
    return {
        paper: {
            width: collisionPopoverWidth,
            padding: theme.spacing(4),
            fontSize: fontSizeSmaller,
        },
    };
});
exports.ApprovalSheetCollisionPopover = function () {
    var _a = react_1.default.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var badgeRef = react_1.useRef(null);
    // popover должен быть открыт по умолчанию
    react_1.useEffect(function () {
        if (badgeRef) {
            setAnchorEl(badgeRef.current);
        }
    }, [badgeRef]);
    var handlePopoverOpen = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handlePopoverClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    var badgeClasses = useBadgeStyles();
    var popoverClasses = usePopoverStyles();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: badgeClasses.badge, ref: badgeRef, onClick: handlePopoverOpen, "aria-owns": open ? 'collision-popover' : undefined, "aria-haspopup": "true" },
            react_1.default.createElement(core_1.Grid, { container: true, direction: "row", spacing: 1, alignItems: "center", className: badgeClasses.gridContainer },
                react_1.default.createElement(core_1.Grid, { item: true, className: badgeClasses.badgeText },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: "collisionBadgeTitle" })),
                react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(Warning_1.default, null)))),
        react_1.default.createElement(core_1.Popover, { id: "collision-popover", open: open, anchorEl: anchorEl, onClose: handlePopoverClose, disableRestoreFocus: true, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
            }, classes: popoverClasses },
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "collisionPopoverText", values: {
                    p: utils_1.renderParagraph,
                } }))));
};
